import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValueDTO } from '@ms/core/model/keyvalue.model';
import { Observable } from 'rxjs';
import {
    FeeIncome,
    IIncomePlan,
    IIncomePlanSearchResultDTO,
    IncomePlan,
    IncomePlanSearch,
} from '../income-plans/income-plan.model';
import { logRequest } from '../shared/http-utils';
import { SchoolService } from './school.service';

@Injectable({
    providedIn: 'root',
})
export class IncomePlanService {
    baseUrl = '/school-service/api/income-plans/';

    constructor(
        private http: HttpClient,
        private schoolService: SchoolService
    ) {}

    getById(id: string): Observable<HttpResponse<IIncomePlan>> {
        return this.http.get<IIncomePlan>(this.baseUrl + id, {
            observe: 'response',
        });
    }

    calculateDiscount(feeIncome: FeeIncome): Observable<HttpResponse<FeeIncome>> {
        return this.http.post<FeeIncome>(`${this.baseUrl}calculate-discount`, feeIncome, { observe: 'response' });
    }

    save(budgetIncome: IncomePlan): Observable<HttpResponse<IIncomePlan>> {
        return this.http.post<IncomePlan>(this.baseUrl, budgetIncome, { observe: 'response', headers: logRequest() });
    }

    update(budgetIncome: IncomePlan): Observable<HttpResponse<IIncomePlan>> {
        budgetIncome.schoolId = this.schoolService.getActiveSchool().id;
        return this.http.put<IncomePlan>(this.baseUrl, budgetIncome, { observe: 'response', headers: logRequest() });
    }

    getAllActiveBySchoolId(schoolId: string): Observable<HttpResponse<IIncomePlan[]>> {
        return this.http.get<IIncomePlan[]>(`${this.baseUrl}school/${schoolId}`, {
            observe: 'response',
        });
    }

    delete(id: any): Observable<HttpResponse<any>> {
        return this.http.delete(this.baseUrl + id, {
            observe: 'response',
            headers: logRequest(),
        });
    }
    search(searchDTO: IncomePlanSearch): Observable<HttpResponse<IIncomePlanSearchResultDTO[]>> {
        searchDTO.schoolId = this.schoolService.getActiveSchool().id;
        return this.http.post<IIncomePlanSearchResultDTO[]>(`${this.baseUrl}search`, searchDTO, {
            observe: 'response',
        });
    }

    getIncomePlansKeyValueDTO(budgetId: string): Observable<KeyValueDTO[]> {
        return this.http.get<KeyValueDTO[]>(`${this.baseUrl}active/select/${budgetId}`);
    }

    setActive(id: string, isActive: boolean): Observable<HttpResponse<any>> {
        return this.http.patch<any>(`${this.baseUrl + id}/active/${isActive}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }
}
